var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_vm._v(" "),_vm._l((_setup.components),function(component){return _c(component.name,_vm._g(_vm._b({key:component.id,tag:"component"},'component',component.props,false),component.listeners))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }